// frontend/src/components/Cubes3D.jsx
import React, { forwardRef } from "react";
import useCubesVisualizer from "../hooks/useCubesVisualizer";

// Composant 3D passif, cohérent avec Icosahedron3D
const Cubes3D = forwardRef(({
  running = true,
  chaos = false,
  glow = true,
  cubeSpeedPct = 50,
  ballSpeedPct = 50,
  pulseSpeedPct = 50,
  flashRatePct = 30,
  width = 750,
  height = 500,
}, ref) => {
  // Hook visuel, reçoit directement les props
  const canvasRef = useCubesVisualizer({
    running,
    chaos,
    glow,
    cubeSpeed: cubeSpeedPct / 100,
    ballSpeed: ballSpeedPct / 100,
    pulseSpeed: pulseSpeedPct / 100,
    flashRate: flashRatePct / 100,
  });

  // Forward du ref parent → canvas interne
  React.useImperativeHandle(ref, () => canvasRef.current);

  return (
    <div
      style={{
        width,
        height,
        position: "relative",
        borderRadius: "12px",
        overflow: "hidden",
        boxShadow: "0 0 20px rgba(3,218,198,0.3)",
        background: "radial-gradient(circle at center, #0d1117, #000)",
      }}
    >
      <canvas
        ref={canvasRef}
        id="cubes-canvas"
        data-testid="cubes-canvas"
        width={width}
        height={height}
        style={{
          width: "100%",
          height: "100%",
          display: "block",
        }}
      />
    </div>
  );
});

export default Cubes3D;
